module.exports = __webpack_public_path__ + "static/p_three.clean.02d722c8.jpeg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/p_three.clean.jpeg
// module id = 972
// module chunks = 11